import styles from "./vehicle-list.module.css";
import VehicleFilter from "../Filter";
import List from "./component/List";
import Graph from "./component/Graph";

const VehicleListView = ({
  isGridView,
  handleView,
  filterData,
  setFilterData,
  setAddModalOpen,
  setEditModalOpen,
  setEditData,
  query,
  refreshKey,
  onListChange,
  setSelectedId,
  setDeleteVehicleModalOpen,
  setTenantModalOpen,
  setTenantDetails
}) => {
  return (
    <div className={`${styles.BodyCon}`}>
      <div className={`${styles.mainCardDiv}`}>
        <div className={`${styles.mainCard}`}>
          <div className="control-pane">
            <VehicleFilter
              isGridView={isGridView}
              handleView={handleView.bind(this)}
              filterData={filterData}
              setFilterData={setFilterData.bind(this)}
              setAddModalOpen={setAddModalOpen.bind(this)}
            />

            <div className={`${styles.IncomeListingBody}`}>
              <div className={`${styles.IncomeListSec}`}>
                <List
                  isActive={!isGridView}
                  query={query}
                  refreshKey={refreshKey}
                  onListChange={onListChange}
                  setEditData={setEditData.bind(this)}
                  setEditModalOpen={setEditModalOpen.bind(this)}
                  setSelectedId={setSelectedId.bind(this)}
                  setDeleteVehicleModalOpen={setDeleteVehicleModalOpen.bind(this)}
                  setTenantModalOpen={setTenantModalOpen.bind(this)}
                  setTenantDetails={setTenantDetails.bind(this)}
                />
              </div>
              <div className={`${styles.IncomeGraphSec}`}>
                <Graph
                  isActive={!isGridView}
                  query={query}
                  refreshKey={refreshKey}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VehicleListView;
